import { getTikTokData } from './tiktok.api';
import { parseTikTokTimeSeries } from '../helpers';

const pluralDimensionToSingle = {
    categories: 'category',
    brands: 'brand',
    hashtags: 'hashtag',
};

const getPaginateId = (paginateBy) => (dp) => {
    if (pluralDimensionToSingle.hasOwnProperty(paginateBy))
        return dp[pluralDimensionToSingle[paginateBy]];
    throw new Error(`Unsupported paginateBy value: ${paginateBy}`);
};

const getAllPages = async (fn, config) => {
    const firstPage = await fn({
        ...config,
        data: { page: 1, ...config.data },
    });
    const totalPages = firstPage?.last_page;
    if (totalPages < 2) return firstPage?.data;
    const restOfPages = await Promise.all(
        Array.from({ length: totalPages - 1 }, (_, i) =>
            fn({ ...config, data: { page: i + 2, ...config.data } }),
        ),
    );
    return [firstPage?.data, ...restOfPages.map((page) => page?.data)].flat();
};

const getAllTimeSeriesData = async ({
    sortedData,
    paginateBy,
    country,
    brand,
    category,
    hashtag,
    per_page = 500,
    shapeTimeSeries,
    getTimeSeries,
}) => {
    const proms = [
        getAllPages((config) => getTimeSeries(config), {
            data: {
                per_page,
                country,
                brand,
                category,
                hashtag,
                week: null,
                year: null,
            },
        }),
    ];
    const [timeSeriesData] = await Promise.all(proms);
    const getId = getPaginateId(paginateBy);
    const dataById = new Map();
    sortedData.forEach((dataPoint) => {
        const { name } = dataPoint;
        const id = getId(dataPoint);
        dataById.set(id, { name });
    });
    timeSeriesData.forEach((dataPoint) => {
        const id = getId(dataPoint);
        if (!dataById.has(id)) return;
        const { time_series } = dataPoint;
        dataById.get(id).ts = time_series ? shapeTimeSeries(time_series) : null;
    });
    const tsData = [];
    for (const value of dataById.values()) {
        if (value.ts) tsData.push({ name: value.name, timeSeries: value.ts });
    }
    return tsData;
};

export default getAllTimeSeriesData;
